import React, { Component } from "react";
import { getPersonnelPlayers } from "../../../../modules/player";
import { getPeers, archivePersonnel } from "../../../../modules/user";
import "./archive-personnel-dialog.css";

import Select from 'react-select';

class ArchivePersonnelDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected_personnel_id: -1,
            getting_players: true,
            getting_peers: true,
            players: [],
            peers: [],
            new_owner_id: -1,
            ready_to_archive: false,
            submitting: false
        };
    }
    async componentDidMount() {
        let { personnel_data, token } = this.props;

        let personnelPlayersResponse = await getPersonnelPlayers(personnel_data.id, token);
        let readyToArchive = false;
        if (personnelPlayersResponse && personnelPlayersResponse.data.success) {

            let players = personnelPlayersResponse.data.players;
            if (!players || players.length === 0) {
                readyToArchive = true;
            }
            this.setState({
                getting_players: false,
                players: players,
                ready_to_archive: readyToArchive
            });
        }

        if (!readyToArchive) {
            let peersResponse = await getPeers(token, personnel_data.id);

            if (peersResponse && peersResponse.data.success) {
                this.setState({
                    getting_peers: false,
                    peers: peersResponse.data.peers.personnel
                });
            }
        }
    }

    updateSelectedPersonnel(newOwner) {
        let readyToSubmit = true;

        if (Number(newOwner.value) === -1) {
            readyToSubmit = false;
        }

        this.setState({ selected_personnel_id: newOwner.value, ready_to_archive: readyToSubmit });
    }

    printOtherOrganizationPersonnel() {
        let { personnel_data } = this.props;
        let { peers } = this.state;

        let options = [{
            value: -1,
            label: "Choose One"
        }];

        for (let index in peers) {
            let currentPersonnel = peers[index];

            if (currentPersonnel.id === personnel_data.id) {
                continue;
            }
            let personnelFullName = currentPersonnel.first_name + " " + currentPersonnel.last_name;
            options.push({ value: currentPersonnel.id, label: personnelFullName });
        }
        return (<Select className='archive_personnel_dialog_new_owner_select' options={options} onChange={this.updateSelectedPersonnel.bind(this)} />)
    }

    async submitArchive() {
        let { token, personnel_data, archive_done } = this.props;
        let { submitting, ready_to_archive, selected_personnel_id } = this.state;

        if (!ready_to_archive) {
            return;
        }

        if (submitting) {
            return;
        }

        this.setState({ submitting: true });

        let response = await archivePersonnel(token, personnel_data.id, selected_personnel_id);

        if (response && response.data && response.data.success) {
            archive_done(personnel_data.id);

            this.setState({
                submitting: false
            });
        }
        else {
            alert("Something went wrong...");
            this.setState({
                submitting: false
            });
        }
    }

    render() {
        let { personnel_data, cancel_archive } = this.props;
        let { players, getting_players, ready_to_archive, submitting } = this.state;

        let playersCount = players.length;
        let hasPlayers = players.length > 0;

        let playersString = "players";

        if (playersCount === 1) {
            playersString = "player";
        }

        return (
            <div className='archive_personnel_dialog'>
                {!getting_players &&
                    <div className='archive_personnel_dialog_content'>
                        <div className='archive_personnel_dialog_title'>Are you sure you want to archive <span className='archive_personnel_dialog_name'>{personnel_data.name}</span>?</div>

                        {hasPlayers &&
                            <div>
                                <div className="archive_personnel_reassign_message">{personnel_data.name} has {playersCount} {playersString}, please choose another professional to reassign them.</div>
                                {this.printOtherOrganizationPersonnel()}
                            </div>
                        }

                        {!submitting && ready_to_archive && <div className='archive_personnel_accept' onClick={this.submitArchive.bind(this)}>Archive</div>}
                        {!submitting && !ready_to_archive && <div className='archive_personnel_accept disabled'>Archive</div>}
                        {!submitting && <div className='archive_personnel_cancel' onClick={cancel_archive}>Cancel</div>}
                        {submitting && <div className='archive_loader'>Archiving... <i className='fa fa-spin fa-spinner'></i></div>}
                    </div>
                }
            </div>
        );
    }
}

export default ArchivePersonnelDialog;


// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/archive-personnel-dialog.js